export default "__VITE_ASSET__C95SQX6s__"